import React, { useEffect, useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { X, ShoppingBag } from 'lucide-react';
import { scrollToPricing } from '../utils/scrollTo';
const NAMES = ['Lucía', 'Martín', 'Carolina', 'Federico', 'Sofía', 'Diego', 'Claudia', 'Mateo', 'Valentina', 'Joaquín', 'Facundo', 'Camila'];
const CITIES = ['Mendoza', 'Buenos Aires', 'Córdoba', 'Rosario', 'La Plata', 'Mar del Plata', 'Tucumán', 'Salta', 'Santa Fe', 'Neuquén', 'Bariloche'];
export const PurchasePopup = () => {
  const [isVisible, setIsVisible] = useState(false);
  const [currentPurchase, setCurrentPurchase] = useState({
    name: '',
    city: '',
    time: 0
  });
  useEffect(() => {
    const triggerPopup = () => {
      const randomName = NAMES[Math.floor(Math.random() * NAMES.length)];
      const randomCity = CITIES[Math.floor(Math.random() * CITIES.length)];
      const randomTime = Math.floor(Math.random() * 15) + 1;
      setCurrentPurchase({
        name: randomName,
        city: randomCity,
        time: randomTime
      });
      setIsVisible(true);
      setTimeout(() => {
        setIsVisible(false);
      }, 5000);
    };
    // Initial delay before first popup
    const initialTimer = setTimeout(triggerPopup, 5000);
    // Recurring interval for subsequent popups — every 30 seconds
    const intervalTimer = setInterval(() => {
      triggerPopup();
    }, 30000);
    return () => {
      clearTimeout(initialTimer);
      clearInterval(intervalTimer);
    };
  }, []);
  return <AnimatePresence data-id="element-80">
      {isVisible && <motion.div initial={{
      opacity: 0,
      y: 50,
      scale: 0.9
    }} animate={{
      opacity: 1,
      y: 0,
      scale: 1
    }} exit={{
      opacity: 0,
      y: 20,
      scale: 0.9
    }} transition={{
      type: 'spring',
      stiffness: 300,
      damping: 25
    }} className="fixed bottom-24 md:bottom-6 left-4 md:left-6 z-50 bg-white rounded-lg shadow-xl border border-slate-200 p-4 max-w-[320px] flex items-start gap-3" role="status" aria-live="polite" data-id="element-81">
          <div className="bg-teal-100 p-2 rounded-full flex-shrink-0 mt-1" data-id="element-82">
            <ShoppingBag className="w-5 h-5 text-teal-700" data-id="element-83" />
          </div>
          <div data-id="element-84">
            <p className="text-sm font-medium text-slate-800 leading-tight" data-id="element-85">
              🎉 <span className="font-bold" data-id="element-86">{currentPurchase.name}</span> de{' '}
              {currentPurchase.city} acaba de comprar el Megapack Élite
            </p>
            <p className="text-xs text-slate-500 mt-1" data-id="element-87">
              hace {currentPurchase.time} min
            </p>
          </div>
          <button onClick={() => setIsVisible(false)} className="text-slate-400 hover:text-slate-600 absolute top-2 right-2" aria-label="Cerrar notificación" data-id="element-88">
            <X className="w-4 h-4" data-id="element-89" />
          </button>
        </motion.div>}
    </AnimatePresence>;
};
export const StickyCTA = () => {
  const [showSticky, setShowSticky] = useState(false);
  useEffect(() => {
    const handleScroll = () => {
      // Show sticky CTA after scrolling past the hero section (approx 600px)
      if (window.scrollY > 600) {
        setShowSticky(true);
      } else {
        setShowSticky(false);
      }
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);
  return <AnimatePresence data-id="element-90">
      {showSticky && <motion.div initial={{
      y: 100
    }} animate={{
      y: 0
    }} exit={{
      y: 100
    }} className="fixed bottom-0 left-0 right-0 z-40 bg-white border-t border-slate-200 shadow-[0_-4px_6px_-1px_rgba(0,0,0,0.1)] p-4 md:hidden flex justify-center" data-id="element-91">
          <button onClick={scrollToPricing} className="w-full max-w-md bg-teal-700 hover:bg-teal-800 text-white font-bold py-3 px-6 rounded-xl shadow-lg transform transition active:scale-95 flex items-center justify-center gap-2" data-id="element-92">
            🚀 Empezá hoy — Quiero mi sistema
          </button>
        </motion.div>}
    </AnimatePresence>;
};